import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import LetterAuthorisationBatchCriteria from '../../../Models/LetterAuthorisation/Commands/LetterAuthorisationBatchCriteria';
import { EnumHelper, Misc } from '@singularsystems/neo-core';
import { ReportType } from '../../../Models/LetterAuthorisation/ReportType';
import { AppService, DomainTypes } from '../../../DomainTypes';

interface IBatchCriteriaProps {
    criteria: LetterAuthorisationBatchCriteria;
    autoRunner: Misc.IAutoRunner;
}

@observer
export default class BatchCriteria extends React.Component<IBatchCriteriaProps> {

    constructor(props: IBatchCriteriaProps) {
        super(props);
    }

    private dataCache = AppService.get(DomainTypes.Services.DataCache);
    private investorApiClient = AppService.get(DomainTypes.ApiClients.Investor);

    public render() {
        const { criteria, autoRunner } = this.props;

        return (
            <Neo.Form model={criteria} onSubmit={() => autoRunner.fireImmediate()}>
                <Neo.GridLayout md={2} xl={4}>
                    <Neo.FormGroup bind={criteria.meta.startDate} label="From" />
                    <Neo.FormGroup bind={criteria.meta.endDate} label="To" />
                    <Neo.FormGroup bind={criteria.meta.reportType} 
                        select={{ items: EnumHelper.asList(ReportType) }} />
                    <Neo.FormGroup bind={criteria.meta.entityId} 
                        select={{ itemSource: this.dataCache.entities }} />
                </Neo.GridLayout>
                {criteria.reportType === ReportType.BankTransferFormCapital &&
                    <Neo.GridLayout md={2} xl={4}>
                        <Neo.FormGroup bind={criteria.meta.investorReferralTypeId} select={{ itemSource: this.dataCache.investorReferralTypes }} />
                        <Neo.FormGroup>
                            <Neo.AutoCompleteDropDown bind={criteria.meta.investorId} bindDisplay={criteria.meta.investor} itemSource={this.investorApiClient.getInvestorLookups} />
                        </Neo.FormGroup>
                    </Neo.GridLayout>}
            </Neo.Form>
        );
    }
}